module.exports = __webpack_public_path__ + "img/cup-gold.b1dab2d2.png";